import React from "react";

import { AiOutlineUnorderedList } from "react-icons/ai";
import { BiNews, BiBox } from "react-icons/bi";
import { FiBox, FiDatabase, FiTruck } from "react-icons/fi";
import {
    FaClipboard,
    FaScroll,
    FaWrench,
    FaFlask,
    FaSignal,
    FaRocket,
} from "react-icons/fa";
import { BsFillPeopleFill, BsGear, BsQuestionSquare } from "react-icons/bs";

import { NavbarDisplayIcon } from "../types/navbar";
import { GrTextAlignRight } from "react-icons/gr";

interface Props {
    iconName: NavbarDisplayIcon | "";
}

const NavbarIcon: React.FC<Props> = ({ iconName }) => {
    switch (iconName) {
        case NavbarDisplayIcon.Tag:
            return <AiOutlineUnorderedList />;
        case NavbarDisplayIcon.Category:
            return <BiBox />;
        case NavbarDisplayIcon.Process:
            return <BsGear />;
        case NavbarDisplayIcon.Application:
            return <FaFlask />;
        case NavbarDisplayIcon.Custom:
            return <BsQuestionSquare />;
        case NavbarDisplayIcon.Product:
            return <FiBox />;
        case NavbarDisplayIcon.News:
            return <BiNews />;
        case NavbarDisplayIcon.Article:
            return <FaScroll />;
        case NavbarDisplayIcon.Supplier:
            return <FiTruck />;
        case NavbarDisplayIcon.Dashboard:
            return <FaClipboard />;
        case NavbarDisplayIcon.Analytics:
            return <FaSignal />;
        case NavbarDisplayIcon.Deployments:
            return <FaRocket />;
        case NavbarDisplayIcon.PanelManagement:
            return <FaWrench />;
        case NavbarDisplayIcon.Access:
            return <BsFillPeopleFill />;
        case NavbarDisplayIcon.Logs:
            return <GrTextAlignRight />;
        case NavbarDisplayIcon.Backups:
            return <FiDatabase />;
        default:
            return null;
    }
};

export default NavbarIcon;
